import { Reducer } from "redux";

import {
    BLOGS_SHORT_MESSAGE_DETAIL_FETCH_FAILURE,
    BLOGS_SHORT_MESSAGE_DETAIL_FETCH_REQUEST,
    BLOGS_SHORT_MESSAGE_DETAIL_FETCH_SUCCESS,
    BlogsShortMessageDetailFetchFailureAction,
    BlogsShortMessageDetailFetchRequestAction,
    BlogsShortMessageDetailFetchSuccessAction,
} from "@/mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetail.actions";
import { tupdate } from "@/mk2/helpers/types";
import { errorMessage } from "@/mk2/reducers/errorMessage";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";

export interface BlogsShortMessageDetailState {
    errorMessage: string;
    loadingState: LoadingState;
    postId: number;
}

export const initialBlogsShortMessageDetailState: BlogsShortMessageDetailState = {
    errorMessage: null,
    loadingState: LoadingState.INIT,
    postId: null,
};

const stateKey = (action: BlogsShortMessageDetailReducerAction) =>
    `${action.username}/${action.postSlug}`;

export interface BlogsShortMessageDetailPagesState {
    [key: string]: BlogsShortMessageDetailState;
}

const initialBlogsShortMessageDetailPagesState: BlogsShortMessageDetailPagesState = {};

declare type BlogsShortMessageDetailReducerAction =
    | BlogsShortMessageDetailFetchRequestAction
    | BlogsShortMessageDetailFetchSuccessAction
    | BlogsShortMessageDetailFetchFailureAction;

export const blogsShortMessageDetailReducer: Reducer<BlogsShortMessageDetailPagesState> = (
    state = initialBlogsShortMessageDetailPagesState,
    action: BlogsShortMessageDetailReducerAction,
) => {
    switch (action.type) {
        case BLOGS_SHORT_MESSAGE_DETAIL_FETCH_REQUEST:
        case BLOGS_SHORT_MESSAGE_DETAIL_FETCH_FAILURE: {
            const key = stateKey(action);
            return tupdate(state, {
                [key]: tupdate(state[key] || initialBlogsShortMessageDetailState, {
                    errorMessage: errorMessage(undefined, action),
                    loadingState: loadingState(undefined, action),
                }),
            });
        }

        case BLOGS_SHORT_MESSAGE_DETAIL_FETCH_SUCCESS: {
            const key = stateKey(action);
            return tupdate(state, {
                [key]: tupdate(state[key] || initialBlogsShortMessageDetailState, {
                    errorMessage: errorMessage(undefined, action),
                    loadingState: loadingState(undefined, action),
                    postId: action.response.result.post,
                }),
            });
        }

        default:
            return state;
    }
};
